export enum SeGeneratorType {
  WINDLAND = "BTN_Land based",
  WINDOCEAN = "BTN_Ocean based",
  SOLAR = "BTN_Sun",
  HYDRO = "BTN_Water",
  THERMAL = "BTN_Thermal",
}

export enum SeThermalSubtype {
  INDUSTRIAL_BACK_PRESSURE = "BTN_Industrial back pressure",
  CONDENSING_POWER = "BTN_Condensing power",
  GAS_ENGINE = "BTN_Gas engine",
}

export enum MeteringLocation {
  DIRECTLY_AFTER_GENERATOR = "Directly_after_generator",
  AFTER_AUXILIARY_EQUIPMENT = "After_auxiliary_equipment",
  AFTER_NET_PUMPING_EQUIPMENT = "After_net_pumping_equipment",
  DIRECTLY_BEFORE_GRID_CONNECTION = "Directly_before_grid_connection",
}

export enum RegistrationStatus {
  REGISTERED = "Registered_with_the_S_E_A",
  NOT_REGISTERED = "Not_registered_with_the_S_E_A",
}

export enum CorrectionFactor {
  STANDARD_VALUE = "Standard_value",
  CUSTOM_VALUE = "Custom_value",
}

export enum InvestmentSupport {
  YES = "Yes",
  NO = "No",
  DONT_KNOW = "Do not know",
}

export enum FlowType {
  AUTHORIZATION = "authorization",
  NEW_DEVICE = "new_device",
  CONVERSION = "conversion",
}
